
import { MapConfig } from 'lib-customizations/types'
const mapConfig: MapConfig = {
  center: [64.40465, 27.84563],
  initialZoom: 13,
  addressZoom: 14,
  searchAreaRect: {
    maxLatitude: 64.7097021115188,
    minLatitude: 61.35848873922288,
    maxLongitude: 28.000479607294263,
    minLongitude: 27.703159107936858,
  },
  careTypeFilters: ['DAYCARE', 'PRESCHOOL', 'CLUB'],
  unitProviderTypeFilters: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'PRIVATE_SERVICE_VOUCHER',
  ],
}

export default mapConfig
